import { useContext, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import axiosInstance from "../../../services/authWrapper";
import { init } from "onfido-sdk-ui";
import TenantContext from "../../../context/tenant/TenantContext";

const GuarantorIdStep = (props) => {
  const { guarantorData, loadGuarantorData } = props;
  const { _t } = useTranslator();
  const { onfidoKyc } = useContext(TenantContext);
  const [buttonDisable, setButtonDisable] = useState(false);

  const initiateOnfido = () => {
    setButtonDisable(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/kyc/${guarantorData?._id}?guarantor=true`
      )
      .then((res) => {
        //console.log("ONFIDO WITH WORKFLOW= ", res.data);
        setButtonDisable(false);
        initiateKyc(res.data.sdk_data.token, res.data.workflow_data.id);
      })
      .catch((err) => {
        //console.log("Error Onfido = ", err);
        setButtonDisable(false);
      });
  };

  const initiateKyc = (token, workFlowRunId) => {
    //console.log("On Fido Token = ", token);
    setButtonDisable(true);
    let onfido = {};

    onfido = init({
      token: token,
      useModal: true,
      isModalOpen: true,
      language: localStorage.getItem("i18nextLng") == "es" ? "es" : "en_US",
      containerId: "onfido-mount",
      workflowRunId: `${workFlowRunId}`,
      onComplete: function (data) {
        console.log("everything is complete");

        setButtonDisable(false);
        saveOnfidoKycResponse(data);
        // loadUser(userType);
      },
      onError: function (err) {
        setButtonDisable(false);
      },
      onUserExit: function (userExitCode) {
        console.log("user exitted", userExitCode);
        setButtonDisable(false);
      },
      onModalRequestClose: function () {
        // Update options with the state of the modal
        onfido.setOptions({ isModalOpen: false });
        setButtonDisable(false);
        console.log("modal closed of onfido");
      },
      //steps: ['welcome', 'poa', 'document', 'face', 'complete'],  //poa-proof of address
      steps: ["welcome", "document", "face", "complete"],
    });
  };

  const saveOnfidoKycResponse = (kycData) => {
    onfidoKyc(guarantorData?._id, kycData, "?guarantor=true")
      .then((res) => {
        loadGuarantorData();
      })
      .catch((err) => {});
  };

  return (
    <>
      <div id="onfido-mount"></div>

      <div className=" tenant-doc-tile">
        <div className="border-pd">
          <ul>
            <li className="d-flex tile-design border-0 p-0 m-0">
              <div className="tile-content-wrapper">
                <img src="/images/verify-home-icon.svg" alt="" />
                <div className="tile-content">
                  <h4 className="tile-heading">{_t("verifyId")}</h4>

                  <p className="tile-desc-completed">
                    {_t(
                      "verifyIdGuarantorDescription",
                      "new guarantor flow verify id thing."
                    )}
                  </p>
                </div>
                <div className="d-flex align-items-center gap-4 tile-btns-wrapper ms-auto">
                  {guarantorData?.onfido_kyc_success === false &&
                    (guarantorData?.onfido_user_kyc?.onfido_doc &&
                    guarantorData?.onfido_user_kyc?.onfido_workflow_res
                      ?.status !== "declined" ? (
                      <button className="view-progress">
                        {_t("inProgress")}
                      </button>
                    ) : (
                      <button
                        className="btn btngreen"
                        disabled={buttonDisable}
                        onClick={initiateOnfido}
                      >
                        {_t("complete")}
                      </button>
                    ))}
                  {guarantorData?.onfido_kyc_success === true && (
                    <button className="grey-completed-btn">
                      {_t("completed")}
                    </button>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default GuarantorIdStep;
